import {
    useRef,
} from 'react'
import isEqual from 'lodash/isEqual'

const useStableValue = <T>(value: T) => {
    const requestRef = useRef<T>(value)

    if (!isEqual(requestRef.current, value)) {
        requestRef.current = value
    }

    return requestRef.current
}

export default useStableValue
